module.exports = __webpack_public_path__ + "media/item05.c49e05d7.webm";